var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7241 9.65518C19.8287 9.65518 20.7241 8.79062 20.7241 7.72414C20.7241 6.65766 19.8287 5.79311 18.7241 5.79311L7.55255 5.7931L10.1383 3.29648C10.9194 2.54237 10.9194 1.3197 10.1383 0.565585C9.35729 -0.18853 8.09096 -0.188529 7.30991 0.565587L1.30991 6.35869C0.934833 6.72083 0.724121 7.21199 0.724121 7.72414C0.724121 8.23628 0.934833 8.72745 1.30991 9.08958L7.30991 14.8827C8.09095 15.6368 9.35728 15.6368 10.1383 14.8827C10.9194 14.1286 10.9194 12.9059 10.1383 12.1518L7.55255 9.65517L18.7241 9.65518Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.7241,
    y1: 7.72414,
    x2: 0.724121,
    y2: 7.72414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59B9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D92A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.675be955.svg";
export { ForwardRef as ReactComponent };